import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { Constants } from '../../utils/constants';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {

  ROLES = Constants.ROLES;

  @Input() columns: any[];
  @Input() data = [];
  @Input() currentPage;
  @Input() pageSize;
  @Input() totalItems;
  @Input() isLoading;
  @Input() hideEditInGlobalItem;
  @Input() hideDeleteInGlobalItem;
  @Input() titleCard: string;
  @Input() statusOptions: any[] = [];

  @Input() hideEditAction: boolean = false;
  @Input() hideDeleteAction: boolean = false;
  @Input() hideViewAction: boolean = true;
  @Input() hideSearchBar: boolean = false;
  @Input() hideChangeMode: boolean = false;

  @Output() loadMore = new EventEmitter<string>();
  @Output() editRow = new EventEmitter<string>();
  @Output() viewRow = new EventEmitter<string>();
  @Output() deleteRow = new EventEmitter<string>();
  @Output() deleteManyRow = new EventEmitter<any[]>();
  @Output() sendSearch = new EventEmitter<string>();
  @Output() statusAction = new EventEmitter<string>();
  @Output() copyOnClipboardRow = new EventEmitter<string>();
  @Output() reSendRow = new EventEmitter<string>();

  constructor(private localStorage: LocalStorageService) { }

  ngOnInit(): void {
  }

  filterColumns() {
    if (this.columns) {
      return this.columns.filter(x => { return x.type != 'actions' });
    } else {
      return;
    }
  }

  getActionCol() {
    if (this.columns) {
      return this.columns.filter(x => { return x.type == 'actions' });
    } else {
      return;
    }
  }

  deleteAction(btnElement, row) {
    btnElement && btnElement.parentElement && btnElement.parentElement.parentElement && btnElement.parentElement.parentElement.blur();
    this.deleteRow.emit(row);
  }

  showEdit(row) {
    if (this.hideEditInGlobalItem) {
      if (row.clientID || row.clientId) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  showDelete(row) {
    let user = this.localStorage.getUser();
    if (user.isSuperAdmin() && user.clientID == null) {
      return true;
    }
    if (this.hideDeleteInGlobalItem) {
      if (row.clientID || row.clientId) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  getIndexFirstText() {
    let rows = this.filterColumns();
    if (rows[0].type == 'image') {
      return 1;
    }
    return 0;
  }

}
